import { render, staticRenderFns } from "./PersonalityTestResult.vue?vue&type=template&id=34a2c667&"
import script from "./PersonalityTestResult.vue?vue&type=script&lang=js&"
export * from "./PersonalityTestResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports